import { useState } from "react";
import { NavLink } from "react-router-dom";
import { STUDIO_URL } from "../lib/runtimeConfig.js";

// Warm, light header. Studio is an external link to the live Studio app;
// "Request a Quote" routes to the Plan a Trip flow.
const NAV_ITEMS = [
  { to: "/plan-a-trip", label: "Plan a Trip" },
  { to: "/flights", label: "Flights" },
  { to: "/stays", label: "Stays" },
  { to: "/visas", label: "Visas" },
  { to: "/experiences", label: "Experiences" },
  { to: "/africa", label: "Africa" },
  { to: "/track-trip", label: "Track Trip" },
];

export default function TopNav() {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <header className="topnav">
      <div className="container topnav-inner">
        <NavLink to="/" className="brand" onClick={close} aria-label="513Travel home">
          <span className="brand-mark" aria-hidden="true">513</span>
          <span className="brand-word">Travel</span>
        </NavLink>

        <button
          type="button"
          className="nav-toggle"
          aria-label="Toggle navigation"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          {open ? "✕" : "☰"}
        </button>

        <nav className={`nav-links ${open ? "is-open" : ""}`} aria-label="Primary">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              onClick={close}
              className={({ isActive }) => `nav-link ${isActive ? "is-active" : ""}`}
            >
              {item.label}
            </NavLink>
          ))}
          <a
            className="nav-link"
            href={STUDIO_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={close}
          >
            Studio ↗
          </a>
          <NavLink to="/plan-a-trip" className="btn gold small nav-cta" onClick={close}>
            Request a Quote
          </NavLink>
        </nav>
      </div>
    </header>
  );
}
